import axios from "axios";
import baseUrl from "./base-url";
import Cookies from "js-cookie";
import store from "../common/store/store";
import { logout } from "../common/actions/authActions";

const axiosInstance = axios.create({
    baseURL: baseUrl,
    withCredentials: true, // Ensure cookies (refreshToken) are sent
});

// Request Interceptor (Optional: Attach Access Token to Requests)
axiosInstance.interceptors.request.use(
    (config) => {
        const token = Cookies.get("token");
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor (Handles Token Expiry)
axiosInstance.interceptors.response.use(
    (response) => response, // Pass valid responses through
    async (error) => {
        const originalRequest = error.config;

        // Check if the error is due to an expired token (401 Unauthorized)
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true; // Prevent infinite loop

            try {
                // Call the refresh token API
                const refreshResponse = await axios.post(`${baseUrl}/admin/refresh-token`, {}, { withCredentials: true });

                // Update the new access token
                const newAccessToken = refreshResponse.data.accessToken;
                // localStorage.setItem("accessToken", newAccessToken);
                // Cookies.set("accessToken", newAccessToken);

                // Retry the original request with the new access token
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                console.error("Token refresh failed", refreshError);
                store.dispatch(logout())
                localStorage.removeItem("selectedSociety")
                localStorage.removeItem("accessToken"); 
                window.location.href = "/"; 
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
